module.exports = __webpack_public_path__ + "images/emoji/grinning.1aa40c8fd1f83adeefc6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/grinning.png
// module id = /ms3
// module chunks = 2